import {
  GetNotificationsQuery,
  GetNotificationsQueryVariables,
  MarkAllNotificationsReadMutation,
  MarkAllNotificationsReadMutationVariables,
  MarkNotificationReadMutation,
  MarkNotificationReadMutationVariables,
} from '@/typings/domain'
import numberToBase64 from '../utils/numberToBase64'
import apolloClient from './apolloClient'
import GetNotificationsGQL from './graphql/GetNotifications.graphql'
import MarkAllNotificationsReadGQL from './graphql/MarkAllNotificationsRead.graphql'
import MarkNotificationReadGQL from './graphql/MarkNotificationRead.graphql'

export function markAllNotificationsRead() {
  return apolloClient.mutate<MarkAllNotificationsReadMutation, MarkAllNotificationsReadMutationVariables>({
    mutation: MarkAllNotificationsReadGQL,
    variables: { input: {} },
    fetchPolicy: 'no-cache',
  })
}

export function getNotifications(pageSize: number, page: number, verb?: string, read?: boolean) {
  const after = page === 1 ? undefined : numberToBase64((page - 1) * pageSize)

  return apolloClient.query<GetNotificationsQuery, GetNotificationsQueryVariables>({
    query: GetNotificationsGQL,
    variables: { first: pageSize, after, verb, read },
    fetchPolicy: 'no-cache',
  })
}

export function markNotificationRead(notificationId: string) {
  return apolloClient.mutate<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>({
    mutation: MarkNotificationReadGQL,
    variables: { input: { id: notificationId } },
    fetchPolicy: 'no-cache',
  })
}
